import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";
import { Button, ButtonSize, ButtonVariant } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

type ConversationImageSettingsButtonProps = {
  onPress: () => void;
};

export default function ConversationImageSettingsButton({ onPress }: ConversationImageSettingsButtonProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.ChatImageImageGenerationSettings}>
      <Button data-testid="ConversationImageSettingsButton" variant={ButtonVariant.OUTLINED} size={ButtonSize.LARGE} onClick={onPress}>
        <Trans i18nKey="chat:modal.generationSettings.cta.imageSettings" />
      </Button>
    </CapabilityGate>
  );
}
